import React from "react";
import noDataimg from "./noDataImage.png";


export function NoDataFound({
  title = "No Data Found",
  message = "We couldn't find any data at the moment. Please check back later.",
  imageSize = "w-64 h-64",
}) {
  return (
    <div className="flex flex-col items-center justify-center w-full ">
      <img
        src={noDataimg || "/placeholder.svg"}
        alt={title}
        className={`${imageSize} mb-3 object-contain`}
      />
      <h3 className="text-xl font-semibold text-gray-800 mb-2">{title}</h3>
      <p className="text-gray-600 text-center max-w-md">{message}</p>
    </div>
  );
}
